import {Routes} from '@angular/router';
import {LoginCallback} from '../authentication/login-callback/login-callback';
import {EmptyPage} from '../pages/empty-page/empty-page';
import {ClaimWizard} from '../claims/boundary/claim-wizard/claim-wizard';
import {AuthGuard} from '../authentication/auth-guard-guard';
import {ClaimsOverview} from '../claims/boundary/claims-overview/claims-overview';
import {HomePage} from '../pages/home-page/home-page';
import {ClaimSearch} from '../claims/boundary/claim-search/claim-search';
import {UserProfile} from '../authentication/user-profile/user-profile';
import {BatchUpload} from '../claims/boundary/batch-import/batch-upload/batch-upload';

export const routes: Routes = [
  {
    path: 'callback',
    component: LoginCallback
  },
  {
    path: 'claim/create/:type',
    component: ClaimWizard,
    canActivate: [AuthGuard],
    data: {}
  },
  {
    path: 'claim/batch-upload',
    component: BatchUpload,
    canActivate: [AuthGuard],
    data: {}
  },
  {
    path: 'user/me',
    component: UserProfile,
    canActivate: [AuthGuard],
    data: {}
  },
  {
    path: 'claims-overview',
    component: ClaimsOverview,
    canActivate: [AuthGuard],
    data: {}
  },
  {
    path: 'claims-search',
    component: ClaimSearch,
    canActivate: [AuthGuard],
    data: {}
  },
  {
    path: 'dashboard',
    component: HomePage,
    canActivate: [AuthGuard],
    data: {}
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/dashboard',
    data: {}
  },
  {
    path: '**',
    component: EmptyPage
  }
];
